import React, { createRef, Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { setRef } from '../../utils';
import { ObserveMutations } from '../Observe';
import {
  COLLAPSIBLE_DEFAULTS,
  COLLAPSIBLE_OBSERVER_OPTIONS,
  COLLAPSIBLE_TYPES,
} from './constants';

export default class Collapsible extends Component {
  static propTypes = COLLAPSIBLE_TYPES;
  static defaultProps = COLLAPSIBLE_DEFAULTS;

  cachedHeight = undefined;
  childContent = createRef();
  childWrapper = createRef();

  componentDidMount() {
    this.setChildContentHeight();
  }

  componentDidUpdate() {
    this.setChildContentHeight();
  }

  getObserverOptions = (options) => ({
    ...COLLAPSIBLE_OBSERVER_OPTIONS,
    ...options,
  });

  // THIS FUNCTION IS CAUSING EDGE CASE ISSUES IN ACCORDION WHERE STYLE ATTRIBUTE MUST BE OVERCOME USING !IMPORTANT. IF ADDITIONAL PROBLEMS OCCUR IN OTHER PLACES WE SHOULD CONSIDER REMOVING THIS FUNCTION AND TESTING IT'S NUMEROUS IMPLEMENTATIONS FOR ISSUES AFTER UPDATING
  // Batch the DOM read/write to prevent thrashing and compare against a cached height to control
  // unecessary updates since this method is called often. Using setAttribute is better than keeping
  // this value in state because it allows batch these operations and where they occur in a frame.
  setChildContentHeight = () => {
    const { current: currentContent } = this.childContent;
    const { current: currentWrapper } = this.childWrapper;
    window.requestAnimationFrame(() => {
      const height =
        currentContent && this.props.expanded ? currentContent.clientHeight : 0;
      if (this.cachedHeight && this.cachedHeight === height) {
        return;
      }
      this.cachedHeight = height;
      currentWrapper &&
        currentWrapper.setAttribute('style', `height: ${height}px`);
    });
  };

  setMutationRef = (mutationRef) => (node) => {
    mutationRef(node);
    setRef(this.childContent, node);
  };

  setWrapperRef = (node) => {
    setRef(this.childWrapper, node);
    if (this.props.collapsibleRef) {
      setRef(this.props.collapsibleRef, node);
    }
  };

  render() {
    const {
      children,
      className,
      collapsibleRef,
      contentClassName,
      expanded,
      id,
      observerOptions,
      ...rest
    } = this.props;

    const stateClasses = { 'is-open': !!expanded };
    const classes = cn('c-collapsible', stateClasses, className);
    const contentClasses = cn(
      'c-collapsible__content',
      stateClasses,
      contentClassName
    );
    const builtObserverOptions = this.getObserverOptions(observerOptions);

    return (
      <div className={classes} id={id} ref={this.setWrapperRef} {...rest}>
        <ObserveMutations
          observerOptions={builtObserverOptions}
          onMutation={this.setChildContentHeight}
        >
          {(mutationRef) => (
            <div
              className={contentClasses}
              ref={this.setMutationRef(mutationRef)}
            >
              {children}
            </div>
          )}
        </ObserveMutations>
      </div>
    );
  }
}
